module.exports = __webpack_public_path__ + "static/media/Savings_Diagram_Desktop_SV.5789cd2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Savings_Diagram_Desktop_SV.png
// module id = 556
// module chunks = 0